import { render, staticRenderFns } from "./UnpaidFeesCard.vue?vue&type=template&id=2d6a702a&scoped=true&"
import script from "./UnpaidFeesCard.vue?vue&type=script&lang=ts&"
export * from "./UnpaidFeesCard.vue?vue&type=script&lang=ts&"
import style0 from "./UnpaidFeesCard.vue?vue&type=style&index=0&id=2d6a702a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a702a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
